import Vue from 'vue'
import {Utils} from 'hasta-la-vista-ui-core'
import {MovieService, MovieMetaService, AuthService, OrderService,PreviewService, EcomTrackingService, RegionService} from 'hasta-la-vista-middleware-api/service'
import objectFitImages from 'object-fit-images';
import moment from 'moment'
import dayjs from 'dayjs'
import MetaData from  '../../../mixins/meta-data.js'
import VueObserveVisibility from 'vue-observe-visibility'
import MovieCard from "@/components/cards/movieCard";

Vue.use(VueObserveVisibility)

const ecomTrackedMovies = []

export default {
    name: 'home',

    mixins: [MetaData],

    components: {
        MovieCard,
    },

    data () {
        return {
            loading: true,
            previewMode:false,
            top: 0,
            // Feature carousel temp data
            featuredData: null,
            form_data: {
                count: 0,
                place_query: null,
                keyword: null,
                selected_cinema: null,
                genres: null,
                cinema_types: [],
                filter_group: {
                    genres: null,
                    cinema_types: null,
                },
                dates: null,
                doInitialSearch: false,
            },
            filter: {
                filter_group: {},
                keyword: null,
                place_query: null,
                selected_cinema: {
                    id: null,
                    latitude: null,
                    longitude: null,
                    name: null,
                    original_name: null,
                },
                experiences: null,
                genres: null,
            },
            // Movie data
            movies: null,
            availableCinemas: [],
            activeMovie: null,
            movieSummary: null,
            bottomOffset: null,
            tabNowShowing: null,
            tabComingSoon: null,
            predictiveText: [],
            // Dialogs
            activeDialog: false,
            dialogData: null,
            selected_cinema_id: null,
            selected_experiences:[],
            selected_cinema: null,
            selected_dates: null,
            toastOptions: null,
            doSearch: true,
            skclubAlert: false,
            leftAd: null,
            rightAd: null,
            featureCarouselHeight: 0,
            user: null,
            showLoadMoreNowShowing: this.$breakpoints.xs ? true : false,
            showLoadMoreComingSoon: this.$breakpoints.xs ? true : false,
            loadMoreLimitNowShowing: 16,
            loadMoreLimitComingSoon: 16,
            loadMoreIncrement: 16,
            isVisible: false,
            scrollY: 0,
            visibleMovies: [],
            cinemasByRegion: [],
            cinemaTypes: [],
            movieGenres: [],
            filterOptions: null,
            searchResultCount: null,
            cinemasNearby: null,
            summary_data: {
                types: null,
                dates: null,
            },
            summary_types: null,
            summary_dates: null,
            summary_cinema_slug: null,
            onNouveau: false,
            regions: {},
            cinemaTypeGroups: [],
            movieMeta: null,
            availableDates: [],
            lastAvailableDate: null,
            type_groups: null,
            result_cinemas: null,
            countNS: 0,
            countCS: 0,
            currentTimeStamp: null,
            foo: "no",
            injected_movies: "{data:'none'}",
            injected_meta: "{data:'none'}",
            injected_regions: "{data:'none'}",
            injected_cinemas: "{data:'none'}",
            prerender: false,
            redirectCinemas: [],
            googleAds: process.env.GOOGLE_AD_ENV == 'production'
                ? {
                    classic: {
                        left: '/40862963/SK-HomeP-Wallpaper-Right',
                        right: '/40862963/SK-HomeP-Wallpaper-Left',
                        top: '/40862963/SK-HomeP-320x50',
                        topLg: '/40862963/SK-HomeP-728x90'
                    },
                    nouveau: {
                        left: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Left',
                        right: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Right',
                        top: '/40862963/SK-EventsAndExperiences-Nouveau-320x50',
                        topLg: '/40862963/SK-EventsAndExperiences-Nouveau-728x90'
                    }
                }
                : {
                    classic: {
                        left: '/40862963/SK-HomeP-Wallpaper-Right',
                        right: '/40862963/SK-HomeP-Wallpaper-Left',
                        top: '/40862963/SK-HomeP-320x50',
                        topLg: '/40862963/SK-HomeP-728x90'
                    },
                    nouveau: {
                        left: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Left',
                        right: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Right',
                        top: '/40862963/SK-EventsAndExperiences-Nouveau-320x50',
                        topLg: '/40862963/SK-EventsAndExperiences-Nouveau-728x90'
                    }
                },
            movieData: [],
            filteredMovieData: [],
            moviesLoaded: false,

        }
    },

    methods: {
        visibilityChanged(isVisible, entry, movie) {
            if(isVisible && !ecomTrackedMovies.includes(movie.id)) {
                var position = 0;
                if(this.tabNowShowing && !movie.coming_soon) {
                    for(let n in this.movieData.now_showing) {
                        if(movie.id == this.movieData.now_showing[n]) {
                            position = (n+1);
                        }
                    }
                }

                if(this.tabComingSoon && movie.coming_soon) {
                    for(let n in this.movieData.coming_soon) {
                        if(movie.id == this.movieData.coming_soon[n]) {
                            position = (n+1);
                        }
                    }
                }

                EcomTrackingService.doDataLayerImpression(movie, position);
                ecomTrackedMovies.push(movie.id)
            }
        },

        showMovieDetail(movie, clickedThumb) {
            let url = "/details/";
            url += movie.movie_id;

            if(this.$route.params.cinema_name != undefined) {
                url += "/cinema/" + this.$route.params.cinema_name;
            }

            if(this.$route.params.cinema_type) {
                url += "/types/" + this.$route.params.cinema_type;
            }

            // if(this.$route.params.dates) {
            //     url += "/date/" + this.$route.params.dates;
            // }

            url +=  "/" + movie.title_slug;

            location.href=url;
        },

        openVideoDialog(feature) {
            this.activeDialog = true
            this.dialogData = feature
        },

        checkNouveauGenres(form_data, url) {
            // let goToClassic = false
            // let goToNouveau = false
            // let hasNouveau = false
            // if(this.onNouveau) {
            //     if(form_data.cinema_types == undefined || form_data.cinema_types == null) {
            //         goToClassic = true
            //     } else {
            //         if(form_data.cinema_types.length == 0) {
            //             goToClassic = true
            //         } else {

            //             for(let g in form_data.cinema_types) {
            //                 if(form_data.cinema_types[g].name == "Nouveau") {
            //                     hasNouveau = true
            //                     goToClassic = true
            //                 }
            //             }
            //         }
            //     }

            //     if(goToClassic && !hasNouveau) {
            //         window.location.href=url
            //     }
            // } else {
            //     if(form_data.cinema_types == undefined || form_data.cinema_types == null) {
            //         goToNouveau = false
            //     } else {
            //         if(form_data.cinema_types.length == 0) {
            //             goToNouveau = false
            //         } else {

            //             for(let g in form_data.cinema_types) {
            //                 if(form_data.cinema_types[g].name == "Nouveau" && !this.onNouveau) {
            //                     hasNouveau = true
            //                     goToNouveau = true
            //                 }
            //             }
            //         }
            //     }

            //     if(goToNouveau && hasNouveau && !this.onNouveau) {
            //         window.location.href=url
            //     }
            // }
        },

        addAvailableDates(dates) {
            this.availableDates = [...new Set([...this.availableDates, ...dates])].sort(function(a, b) {
              return a - b;
            });
        },

        getFilteredMovies(filter) {
            if (this.movieData.length) {
                this.countNS = 0;
                this.countCS = 0;
                var criteria = {
                    cinema_id: false,
                    types: false,
                    genres: false,
                    dates: false,
                    title: false,
                }

                if(this.form_data.selected_cinema != undefined && this.form_data.selected_cinema.id > 0) {
                  criteria.cinema_id = this.form_data.selected_cinema.id
                }

                if(this.redirectCinemas != undefined) {
                    for(let i = 0; i < this.redirectCinemas.length; i++) {
                        if(this.redirectCinemas[i].id == criteria.cinema_id) {
                            let year = new Date().getFullYear();
                            let now = new Date()
                            let month = ('0' + (now.getMonth()+1));
                            let day = now.getDate();
                            let current_date = new Date(year + "-" + month + "-" + day)
                            let cinema_date = new Date(this.redirectCinemas[i].date)

                            if(cinema_date <= current_date) {
                                this.form_data.selected_cinema = null
                                criteria.cinema_id = false
                                window.open(this.redirectCinemas[i].url, "_blank")
                            }
                        }
                    }
                }

                let url = this.setUrlFromFilter(this.form_data);
                let checkNouveauGenres = this.checkNouveauGenres(this.form_data, url)

                let types = this.filterTypes(this.form_data.cinema_types);
                let genres = this.filterGenres(this.form_data.genres);
                let dates = this.filterDates(this.form_data.dates);

                criteria.types = types
                criteria.genres = genres
                criteria.dates = dates
                criteria.title = this.form_data.keyword

                // Set helper var to identify if any criteria has been applied
                const anyCriteriaApplied = (criteria.types || criteria.genres || criteria.dates || criteria.title);

                MovieService.filter(criteria).then((result) => {
                    if(result) {
                        this.filterResult = result;

                        if(result.types && !criteria.types && (criteria.cinema_id || criteria.genres || criteria.dates || criteria.title)) {
                            this.setTypeOptions(this.type_groups, result.types);
                        } else {
                            this.setTypeOptions(this.type_groups, null)
                        }

                        if(result.cinemas && result.cinemas.length > 0 && (criteria.cinema_id || criteria.types) && anyCriteriaApplied) {
                            this.result_cinemas = result.cinemas

                            this.setCinemasByRegion(this.regions, result.cinemas);
                        } else {
                            this.setCinemasByRegion(this.regions, null);
                        }

                        if(result.genres) {
                            if(this.movieMeta != undefined && this.movieMeta != null && !criteria.genres && (criteria.cinema_id || criteria.genres || criteria.dates || criteria.types)) {
                                this.setGenreOptions(this.movieMeta.genres, result.genres)
                            } else {
                                this.setGenreOptions(this.movieMeta.genres, null)
                            }
                        }
                    }
                });

                this.filteredMovieData = JSON.parse(JSON.stringify(this.movieData)).filter((movie) => {
                    let matched = !anyCriteriaApplied;
                    let matchedGenre = false;
                    let matchedType = false;
                    let matchedCinema = false;
                    let matchedDates = false;
                    let matchedTitle = false;
                    const criteriaTypes = criteria.types ? Object.values(criteria.types) : false;

                    if (criteria.genres) {
                        const movieGenres = movie.genres.map((genre) => genre.id);
                        for (let genre in criteria.genres) {
                            if (movieGenres.indexOf(genre) > -1) {
                                matchedGenre = true;
                            }
                        }
                    }

                    if (criteriaTypes) {
                        let movieTypes = [];
                        for (var c = 0; c < criteriaTypes.length; c++) {
                            movieTypes = [...movie.experiences, ...movie.flags];
                            movieTypes = [...new Set(movieTypes)];
                            for (var t = 0; t < movieTypes.length; t++) {
                                if (movieTypes[t].trim() == criteriaTypes[c].trim()) {
                                    matchedType = true;
                                }
                            }
                        }
                    }

                    const movieSessions = movie.sessions;

                    if (movie.sessions.length) {
						if (criteriaTypes) {
							let movieTypes = [];
							const movieExperiences = movie.sessions.map((session) => session.experiences);

							for (var i = 0; i < movieExperiences.length; i++) {
								movieTypes = [...movieTypes, ...movieExperiences[i]];
							}

							movieTypes = [...new Set(movieTypes)];

							if (movieTypes.length) {
								for (var c = 0; c < criteriaTypes.length; c++) {
									for (var t = 0; t < movieTypes.length; t++) {
										if (movieTypes[t].trim() == criteriaTypes[c].trim()) {
											matchedType = true;
										}
									}
								}
							}
						}

						if (criteria.cinema_id) {
							if (movieSessions.find(session => {
								return session.cinema_id == criteria.cinema_id;
							})) {
								matchedCinema = true;
							}
						}



						const movieDates = [...new Set(Object.values(movieSessions.flatMap(session => {
							if (session.dates) {
								const sessionDates = Array.isArray(session.dates) ? session.dates : Object.values(session.dates);
								return sessionDates.map((date) => {return dayjs.unix(date).format('YYYY-MM-DD')});
							} else {
								return false;
							}
						})))];

						if (criteria.dates) {
							if (movieDates.indexOf(criteria.dates) > -1) {
								matchedDates = true;
							}
						} else {
							this.addAvailableDates(movieDates);
						}
					}

                    if (criteria.title) {
                        var search = new RegExp(criteria.title.replace(/[^\w\s]/gi, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "").replace(' ', '').toLowerCase(), "i")
                        var mTitle = movie.title.replace(/[^\w\s]/gi, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "").replace(' ', '').toLowerCase()

                        if(search.test(mTitle)) {
                            matchedTitle = true
                        }
                    }

                    if (
                        (criteria.genres ? matchedGenre : true) &&
                        (criteria.types ? matchedType : true) &&
                        (criteria.cinema_id ? matchedCinema : true) &&
                        (criteria.dates ? matchedDates : true) &&
                        (criteria.title ? matchedTitle : true))
                    {
                        matched = true;
                        if (movie.coming_soon) {
                            this.countCS++;
                        } else {
                            this.countNS++;
                        }
                    } else {
                        matched = false;
                    }

                    return matched;
                });

                if (!this.moviesLoaded) {
                    this.moviesLoaded = true;
                }
            }
        },

        filterTypes(selected_types) {
            var types = {}
            for(let st in selected_types) {
                for(let t in selected_types[st].types) {
                    if(selected_types[st].types[t] != undefined) {
                        if(selected_types[st].types[t].name != undefined && selected_types[st].types[t].name != null) {
                            let type = selected_types[st].types[t].name.trim()
                            types[type] = type
                        }
                    }
                }
            }

            if(!Object.keys(types).length > 0) {
                types = false
            }

            return types
        },

        filterGenres(selected_genres) {
            let genres = {}
            for(let g in selected_genres) {
                if(selected_genres[g] != undefined && selected_genres[g] != null) {
                    if(selected_genres[g].id != undefined && selected_genres[g].id != null) {
                        let genre = selected_genres[g].id
                        genres[genre] = genre
                    }
                }
            }
            if(!Object.keys(genres).length) {
                genres = null
            }

            return genres
        },

        filterDates(selected_dates) {
            if (selected_dates) {
                // movie date_tags is in the following format "2023-11-08 12:30"
                return moment(selected_dates).format('YYYY-MM-DD').toString();
            } else {
                return null;
            }
        },

        scrollDown() {
            window.scroll({top: this.$refs.search_filter.$el.offsetTop / 1.2, left: 0, behavior: 'smooth'})
        },

        showAlerts() {
            if (window.scrollY > document.body.offsetHeight / 3) {
                let currentDate = moment().format('YYYYMMDD')
                let newDate = moment(currentDate).add('1', 'month')
                if (localStorage.getItem('skclubAlert') == null) {
                    this.skclubAlert = true
                    localStorage.setItem('skclubAlert', newDate)
                }
            }
        },

        setVisibleTab(clickedTab) {
            // this will match null if neither options are there
            const tabToggledState = this.$route.path.match(/^(\/coming-soon)|(\/now-showing)/);
            let newPath = this.$route.path;

            if (clickedTab === 'coming-soon') {
                this.tabNowShowing = false;
                this.tabComingSoon = true;
                newPath = tabToggledState ? this.$route.path.replace('now-showing', 'coming-soon') : '/coming-soon' + this.$route.path;
            } else {
                this.tabNowShowing = true;
                this.tabComingSoon = false;
                newPath = tabToggledState ? this.$route.path.replace('coming-soon', 'now-showing') : '/now-showing' + this.$route.path;
            }
            this.$router.push(newPath);
        },

        setCinemasByRegion(raw_regions, filter_cinemas = null) {
            var allowedRegions = []

            if(raw_regions && raw_regions != null && raw_regions != undefined && !this.allowedRegions) {

                if(typeof raw_regions == "object" && Object.keys(raw_regions).length) {
                    for(let i = 0; i < this.redirectCinemas.length; i++) {
                        this.availableCinemas.push(this.redirectCinemas[i].id)
                    }

                    allowedRegions = raw_regions.map((r)=> {
                        let cinemas = r.cinemas.filter((c) => ~this.availableCinemas.indexOf(c.id.toString()) || this.availableCinemas.length == 0);
                        return {
                            id: r.id,
                            name: r.name,
                            cinemas
                        };
                    }).filter((r)=>r.cinemas.length > 0)
                }
            }

            let regions = []
            if(filter_cinemas != null) {
                if(Object.keys(filter_cinemas).length > 0) {
                    let sorted_filter_cineams = null
                    let sorted_regions = null
                    filter_cinemas = MovieService.filterCinemasToRegionModel(filter_cinemas, allowedRegions)
                    sorted_filter_cineams = MovieService.sortfilteredCinemasByDistance(filter_cinemas)
                    sorted_regions = MovieService.sortRegionsByDistance(allowedRegions)
                    if(sorted_filter_cineams != null && sorted_filter_cineams != undefined) {
                        regions = [{name: 'Cinemas', cinemas: sorted_filter_cineams}]
                    }

                    if(this.cinemasNearby != null) {
                        regions = [{name: 'Cinemas Nearby', cinemas: this.cinemasNearby}].concat(regions)
                    }
                }
            } else {
                regions = allowedRegions
                if(this.cinemasNearby != null) {
                    regions = [{name: 'Cinemas Nearby', cinemas: this.cinemasNearby}].concat(regions)
                }
            }

            this.cinemasByRegion = regions;
        },

        setTypeGroups(types) {
            if(types && types != undefined && types != null) {
                if(this.type_groups == null) {
                    return Promise.resolve(MovieService.generateExperienceGroups(types)).then((groups) => {
                        this.type_groups = groups
                        return groups
                    })
                } else {
                    return this.type_groups
                }
            }
        },

        setTypeOptions(types, filter_types) {
            if(types && types != undefined && types != null) {
                Promise.resolve(this.setTypeGroups(types)).then((type_groups) => {
                    if(this.type_groups != null) {
                        var typeData = {}
                        if(this.type_groups && this.type_groups != undefined && this.type_groups != null) {
                            typeData = [{label: 'Cinema Types', items: type_groups}]

                            if(filter_types) {
                                Promise.resolve(MovieService.filterExperienceGroups(this.type_groups, filter_types)).then((groups) => {
                                    if(groups.available != null && groups.available != undefined) {
                                        typeData = [{label: 'Cinema Types', items: groups.available}]
                                    } else {
                                        typeData = [{label: 'Cinema Types', items: groups.other}]
                                    }

                                    this.cinemaTypes = typeData
                                })
                            } else {
                                this.cinemaTypes = typeData
                            }
                        }


                    }
                })
            }
        },

        setGenreOptions(genres, filter_genres) {
            var genreData = {}

            let availableGenres = []
            let otherGenres = []

            if(genres && genres != undefined && genres != null) {
                if(filter_genres && filter_genres != null && filter_genres != undefined) {
                    for(let fg in filter_genres) {
                        for(let g in genres) {
                            if(genres[g] != undefined && genres[g] != null) {
                                if(filter_genres[genres[g].id] != null && filter_genres[genres[g].id] != undefined) {
                                    let exists = false

                                    for(let ag in availableGenres) {
                                        if(availableGenres[ag] != undefined && availableGenres[ag] != null) {
                                            if(availableGenres[ag].id == genres[g].id) {
                                                exists = true
                                            }
                                        }
                                    }

                                    if(!exists) {
                                        availableGenres.push(genres[g])
                                    }
                                }
                            }
                        }
                    }

                    for(let g in genres) {
                        let inAvailable = false
                        if(genres[g] != undefined && genres[g] != null) {
                            for(let ag in availableGenres) {
                                if(availableGenres[ag] != undefined && availableGenres[ag] != null) {
                                    if(availableGenres[ag].id == genres[g].id) {
                                        inAvailable = true
                                    }
                                }
                            }
                        }

                        if(!inAvailable) {
                            let exists = false
                            for(let og in otherGenres) {
                                if(otherGenres[og] != undefined && otherGenres[og] != null) {
                                    if(otherGenres[og].id == genres[g].id) {
                                        exists = true
                                    }
                                }
                            }

                            if(!exists) {
                                otherGenres.push(genres[g])
                            }
                        }
                    }
                    if(availableGenres != null && availableGenres != undefined) {
                        genreData = [{label: "Genres", items: availableGenres}]
                    } else {
                        genreData = [{label: "Genres", items: otherGenres}]
                    }

                } else {
                    genreData = [{label: 'Genres', items: genres}]
                }
            }

            this.movieGenres = genreData
        },

        setUrlFromFilter(criteria) {
            let url = "";

            if (this.$route.matched.length >= 1) {
                url = this.$route.matched[0].path;
            }

            if(criteria && criteria != undefined && criteria != null) {

                if(criteria.selected_cinema != undefined && criteria.selected_cinema != null) {
                    if(criteria.selected_cinema.slug != undefined && criteria.selected_cinema.slug != null) {
                        if(!this.redirectCinemas.includes(criteria.selected_cinema.id)) {
                            url = url + "/cinema/" + criteria.selected_cinema.slug
                            this.summary_cinema_slug = this.form_data.selected_cinema.slug;
                        }
                    }
                }

                if(criteria.cinema_types != undefined && criteria.cinema_types != null) {
                    if(criteria.cinema_types.length > 0) {
                        let types = criteria.cinema_types
                        let typeDict = []
                        for(let t in types) {
                            if(types[t] != undefined && types[t] != null) {
                                typeDict.push(types[t].name)
                            }
                        }

                        if(typeDict.length > 0) {
                            let type_string = typeDict.join()

                            url = url + "/type/" + type_string
                            this.summary_types = type_string
                        }

                    }
                }

                if(criteria.genres && criteria.genres != undefined && criteria.genres != null) {
                    if(criteria.genres.length > 0) {
                        let genres = criteria.genres
                        let genreDict = []

                        for(let g in genres) {
                            if(genres[g] != undefined && genres[g] != null) {
                                genreDict.push(genres[g].name)
                            }
                        }

                        if(genreDict.length > 0) {
                            let genre_string = genreDict.join()
                            url = url + "/genres/" + genre_string
                        }
                    }
                }

                if(criteria.dates && criteria.dates != undefined && criteria.dates != null) {
                    if(criteria.dates) {
                        url = url + "/dates/" + moment(criteria.dates).format('D-MM-YYYY')
                        this.summary_dates = moment(criteria.dates).format('D-MM-YYYY')
                    }
                }
            }


            if(url.length == 0) {
                // setting blank url from filter using current matched route
                // current options / /now-showing /coming-soon
                // url = this.$route.matched[0].path;
                url = "";
            }
            window.history.pushState({}, null, url)
            this.$router.push(url)
            return url

        },

        setFormDataFromRoute() {
            let route_params_set = false
            if(this.$route.params.cinema_name && this.$route.params.cinema_name != undefined && this.$route.params.cinema_name != null) {
                let cinema_slug = this.$route.params.cinema_name
                Promise.resolve(RegionService.getCinemaBySlug(cinema_slug)).then((cinema) => {
                    if(cinema != undefined && cinema != null) {
                        this.form_data.selected_cinema = cinema
                        route_params_set = true
                    }
                });
            }

            if(this.$route.params.cinema_type && this.$route.params.cinema_type != undefined && this.$route.params.cinema_type != null) {
                let route_types = this.$route.params.cinema_type.split(",")

                if(this.type_groups && this.type_groups != undefined && this.type_groups != null) {
                    let type_groups = this.type_groups

                    let selected_types = []

                    for(let tg in type_groups) {
                        if(type_groups[tg] != undefined && type_groups[tg] != null) {
                            for(let rt in route_types) {
                                if(route_types[rt] && route_types[rt] != undefined && route_types[rt] != null) {
                                    if(route_types[rt] == type_groups[tg].name) {
                                        selected_types.push(type_groups[tg])
                                    }
                                }
                            }
                        }
                    }
                    if(selected_types.length > 0) {
                        this.form_data.cinema_types = selected_types
                    }
                }
            }

            if(this.$route.params.genres && this.$route.params.genres != undefined && this.$route.params.genres != null) {
                let route_genres = this.$route.params.genres.split(",")

                if(this.movieMeta && this.movieMeta != undefined && this.movieMeta != null) {
                    if(this.movieMeta.genres && this.movieMeta.genres != undefined && this.movieMeta.genres != null) {
                        let genres = this.movieMeta.genres
                        let selected_genres = []

                        for(let g in genres) {
                            if(genres[g] != undefined && genres[g] != null) {
                                for(let rg in route_genres) {
                                    if(route_genres[rg] != undefined && route_genres[rg] != null) {
                                        if(route_genres[rg] == genres[g].name) {
                                            selected_genres.push(genres[g])
                                        }
                                    }
                                }
                            }
                        }

                        if(selected_genres.length > 0) {
                            this.form_data.genres = selected_genres
                        }
                    }
                }
            }

            if(this.$route.params.dates && this.$route.params.dates != undefined && this.$route.params.dates != null) {
                // break reference just in case, dates are especially sensitive
                let newDate = JSON.parse(JSON.stringify(this.$route.params.dates));
                // its just how moment is, very taxing
                this.form_data.dates = new Date(moment(newDate, 'D-MM-YYYY').format('D MMMM YYYY').toString());
            }

            return route_params_set
        },

        doLoadMoreNowShowing(totalLength) {
            this.loadMoreLimitNowShowing = this.loadMoreLimitNowShowing + this.loadMoreIncrement;

            if (this.loadMoreLimitNowShowing >= totalLength) {
                this.showLoadMoreNowShowing = false
            }
        },

        doLoadMoreComingSoon(totalLength) {
            this.showLoadMoreComingSoon = false;
            this.loadMoreLimitComingSoon = this.loadMoreLimitComingSoon + this.loadMoreIncrement;

            if (this.loadMoreLimitComingSoon >= totalLength) {
                this.showLoadMoreComingSoon = false
            }
        },

        doDataLayerImpressions(movie, position) {
            EcomTrackingService.doDataLayerImpressionsOnScroll(movie, position);
        },

        setGoogleAdPosition(scrollPos) {
            if(!this.$refs.googleAdLeft || !this.$refs.googleAdRight) return

            var headerHeight = 80
            var padding = 20
            let carouselHeight = this.$refs.featureCarousel ? this.$refs.featureCarousel.$el.offsetHeight : 0
            let leftAd = this.$refs.googleAdLeft.$el
            let rightAd = this.$refs.googleAdRight.$el

            let top = Math.max(scrollPos + headerHeight + padding, carouselHeight + headerHeight)
            leftAd.setAttribute('style', `left: -${leftAd.offsetWidth + 20}px; top: ${top}px`)
            rightAd.setAttribute('style', `right: -${rightAd.offsetWidth + 20}px; top: ${top}px`)
        },

        onPageScrolled(scrollPos, direction) {
            this.setGoogleAdPosition(scrollPos)
        },

        onResize(e) {
            this.setGoogleAdPosition(window.scrollY || window.pageYOffset)
        },

        setCinemaOptions(cinemasByRegion) {
            this.cinemasByRegion = cinemasByRegion
        },

        setCinemaTypeOptions(CinemaTypeOptions) {
            this.cinemaTypes = CinemaTypeOptions
        },

        setFilterOptions(filterOptions) {
            this.filterOptions = filterOptions
        },

        setCinemasNearby(cinemasNearby) {
            this.cinemasNearby = cinemasNearby
            this.setCinemasByRegion(this.regions, this.result_cinemas)
        },

        summaryOptions(summary_data) {
            this.summary_data = summary_data
            this.summary_types = summary_data.types
            this.summary_dates = summary_data.dates
            if(this.form_data.selected_cinema) {
                this.summary_cinema_slug = this.form_data.selected_cinema.slug
            }
        },

        setLoading(loading) {
            this.loading = loading
        },

        setCinemaTypeGroups(cinemaTypeGroups) {
            this.cinemaTypeGroups = cinemaTypeGroups
        },

        adsrvrPixel() {
          ttd_dom_ready( function() {
            if (typeof TTDUniversalPixelApi === 'function') {
              var universalPixelApi = new TTDUniversalPixelApi();
              universalPixelApi.init("mxyqca6", ["ytaat3z"], "https://insight.adsrvr.org/track/up");
            }
          });
        }
    },

    computed: {
        expireDate() {
            return localStorage.getItem('skclubAlert') ? localStorage.getItem('skclubAlert') : null
        },

        isNouveau() {
            if(this.form_data.cinemas_types != undefined && this.form_data.cinema_types != null) {
                if(this.form_data.cinema_types.length == 1) {
                    if(this.form_data.cinema_types[0].name == "Nouveau") {
                        this.$root.$el.classList.add('nouveau')
                        return true
                    } else {
                        this.$root.$el.classList.remove('nouveau')
                    }
                } else {
                    this.$root.$el.classList.remove('nouveau')
                }
            } else {
                this.$root.$el.classList.remove('nouveau')
            }
            let isNouveau = this.$route.path.includes('type') && this.$route.path.includes('Nouveau');
            return isNouveau
        },

        googleAdType() {
            return this.isNouveau ? 'nouveau' : 'classic'
        },

        filteredDates() {
            let filteredDates = []
            //console.log("filteredMovieData", this.filteredMovieData)
            if(this.filteredMovieData !== undefined && this.filteredMovieData.length > 0) {
                for(let m = 0; m < this.filteredMovieData.length; m++) {
                    if(this.filteredMovieData[m] !== undefined) {
                        //console.log(this.filteredMovieData[m])
                        if(this.filteredMovieData[m].sessions !== undefined && this.filteredMovieData[m].sessions.length > 0) {
                            for(let s = 0; s < this.filteredMovieData[m].sessions.length; s++) {
                                if(this.filteredMovieData[m].sessions[s] !== undefined) {
                                    if(this.form_data.selected_cinema !== null) {
                                        if(this.filteredMovieData[m].sessions[s].cinema_id == this.form_data.selected_cinema.id) {
                                            for (let d = 0; d < this.filteredMovieData[m].sessions[s].dates.length; d++) {
                                                let new_date = new Date(this.filteredMovieData[m].sessions[s].dates[d] * 1000);
                                                let formatted_date = moment(new_date).format('YYYY-MM-DD')
                                                if(!filteredDates.includes(formatted_date)) {
                                                    filteredDates.push(formatted_date);
                                                }
                                            }
                                        }
                                    } else {
                                        for(let d = 0; d < this.filteredMovieData[m].sessions[s].dates.length; d++) {
                                            let new_date = new Date(this.filteredMovieData[m].sessions[s].dates[d] * 1000);
                                            let formatted_date = moment(new_date).format('YYYY-MM-DD')
                                            if(!filteredDates.includes(formatted_date)) {
                                                filteredDates.push(formatted_date);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return filteredDates
        },
    },

    created() {
        this.previewMode = PreviewService.hasPreviewContent()

        if(this.isNouveau) {
            this.onNouveau = true
        }

        this.adsrvrPixel();

        OrderService.tearDown();

        Promise.all([
            MovieMetaService.getFeaturedContent((this.$route.query.noCache || false)),
            RegionService.getRegions(),
            MovieMetaService.getMovieMeta(),
            MovieService.getMoviesForSearchFilter(),
            RegionService.getRedirectCinemas()
        ]).then(([
            featured,
            regions,
            meta,
            movieData,
            redirectCinemas
        ]) => {
            this.featuredData = PreviewService.addPreviewToContentArrayIfAvailable('featured_content',featured);
            let now = new Date().getTime();

            this.redirectCinemas = redirectCinemas
            this.currentTimeStamp = (now / 1000);

            Promise.resolve(AuthService.user()).then((user) => {
                this.user = user
            })

            this.regions = regions.data
            if(regions.data != undefined && regions.data != null) {
                this.setCinemasByRegion(this.regions);
            }

            this.movieMeta = meta;
            this.lastAvailableDate = meta.last_available_date;

			      if(meta != undefined && meta != null && meta.experiences != undefined && meta.experiences != null && meta.genres != undefined && meta.genres != null) {
                Promise.all([this.setTypeOptions(meta.experiences), this.setGenreOptions(meta.genres)]).then(([types, genres]) => {
                    Promise.resolve(this.setFormDataFromRoute()).then((route_params) => {

                    })
                })
            }

            this.predictiveText = movieData.map(movie => movie.title);

            this.tabNowShowing = this.$route.path.match(/^\/(coming-soon)/g) ? false : true;
            this.tabComingSoon = this.$route.path.match(/^\/(coming-soon)/g) ? true : false;

            let cinemaIds = [];
            movieData.map(movie => { return movie.sessions.length ? movie.sessions.map(session => {cinemaIds.push(session.cinema_id)}) : false });
            this.availableCinemas = cinemaIds;
            this.movieData = movieData;

            this.getFilteredMovies(false);

            if(this.user != null && this.user != undefined) {
                if(this.user.MemberLevelId != undefined) {
                    if (!this.$breakpoints.xs && this.user.MemberLevelId == '19') {
                        let todaysDate = moment().format('YYYYMMDD')
                        if (this.expireDate == null) {
                            document.addEventListener('scroll', this.showAlerts, false)
                        } else if (moment(todaysDate).isAfter(this.expireDate)) {
                            localStorage.removeItem('skclubAlert')
                            document.addEventListener('scroll', this.showAlerts, false)
                        } else {
                            document.removeEventListener('scroll', this.showAlerts)
                        }
                    }
                }
            }

            Vue.nextTick(() => this.setGoogleAdPosition(window.scrollY || window.pageYOffset))
        });
        if (this.$route.path.includes('/type') && this.$route.path.includes("Nouveau") || this.isNouveau) {
            this.metaTitle = 'Cinema Nouveau Movies | Dedicated Art Cinema'
            this.metaDescription = 'Nouveau is a division of Ster-Kinekor Theatres and holds the prestige of being one of the world’s only dedicated "art cinema" chains, screening independent, alternative and art cinema content from cultures across the globe. Book your tickets today!'
            this.metaImage = '/static/img/nouveau-logo.png'
        } else {
            this.metaTitle = 'Cinema | Movie Showtimes and Online Movie Ticket Bookings'
            this.metaDescription = 'South Africa\'s biggest movie exhibitor. Browse the latest movies, trailers and showtimes. Book your movie tickets online today!'
            this.metaImage = '/static/img/sk-logo.png'
        }
        this.schemaDataSrc = {
            '@context' : 'http://schema.org',
            '@type' : 'Organization',
            'name' : 'Ster-Kinekor',
            'logo' : 'https://www.sterkinekor.com/​static/img/sk-logo.png',
            'url' : "https://www.sterkinekor.com",
            'sameAs' : [ '​https://twitter.com/sterkinekor',
                '​https://www.facebook.com/sterkinekortheatres',
                '​https://www.instagram.com/sterkinekor/',
                '​https://www.youtube.com/user/SterKinekorTheatres']
        }
    },

    beforeDestroy() {
        document.removeEventListener('scroll', this.showAlerts)
        window.removeEventListener('resize', this.onResize)
    },


    mounted() {
        if (window.__PRERENDER_INJECTED) {
            this.loading = false
            this.prerender = true

            if(window.__PRERENDER_INJECTED.movies) {
                let injected_movies = MovieService.setPreRenderMovies(window.__PRERENDER_INJECTED.movies)
                let movies = injected_movies
                this.injected_movies = injected_movies.byRelease()
                this.movies = injected_movies.byRelease()

                for(let ns in this.movies.now_showing) {
                    if(this.movies.now_showing[ns] != null && this.movies.now_showing[ns] != undefined && (typeof this.movies.now_showing[ns] == "object")) {
                        this.countNS++
                    }
                }

                for(let ns in this.movies.coming_soon) {
                    if(this.movies.coming_soon[ns] != null && this.movies.coming_soon[ns] != undefined && (typeof this.movies.coming_soon[ns] == "object")) {
                        this.countCS++
                    }
                }
            } else {
                let injected_movies = undefined
                this.injected_movies = injected_movies
            }

            if(window.__PRERENDER_INJECTED.regions) {
                let injected_regions = RegionService.setPreRenderRegions(window.__PRERENDER_INJECTED.regions)
                this.injected_regions = injected_regions
                this.regions = injected_regions.data
                if(this.regions != undefined && this.regions != null) {
                    this.setCinemasByRegion(this.regions);
                }
            } else {
                let injected_regions = undefined
            }

            if(window.__PRERENDER_INJECTED.cinemas) {
                let injected_cinemas = RegionService.setPreRenderRegionsDictionary(window.__PRERENDER_INJECTED.cinemas)
                this.injected_cinemas = window.__PRERENDER_INJECTED.cinemas
            } else {
                let injected_cinemas = undefined
            }

            if(window.__PRERENDER_INJECTED.meta) {
                let injected_meta = MovieMetaService.setPreRenderMovieMeta(window.__PRERENDER_INJECTED.meta)
                this.injected_meta = injected_meta

                let meta = injected_meta
                let featured = meta.featured_content
                this.featuredData = featured

                this.movieMeta = meta;
                this.lastAvailableDate = meta.last_available_date;

                if(meta != undefined && meta != null && meta.experiences != undefined && meta.experiences != null && meta.genres != undefined && meta.genres != null) {
                    if(this.setTypeOptions(meta.experiences) && this.setGenreOptions(meta.genres)) {
                        this.setFormDataFromRoute()
                    }
                }

            } else {
                let injected_meta = undefined
                this.injected_meta = undefined
                let featured = undefined
            }

            this.currentTimeStamp = (now / 1000);
            this.predictiveText = movieData.map(movie => movie.title);

            this.tabNowShowing = this.$route.path.match(/^\/(coming-soon)/g) ? false : true;
            this.tabComingSoon = this.$route.path.match(/^\/(coming-soon)/g) ? true : false;
            let cinemaIds = [];
            movieData.map(movie => { return movie.sessions.length ? movie.sessions.map(session => {cinemaIds.push(session.cinema_id)}) : false });
            this.availableCinemas = cinemaIds;
        }
        objectFitImages(document.querySelector('img.obejct-fit-polyfill'))

        Vue.nextTick(() => this.setGoogleAdPosition(window.scrollY || window.pageYOffset))
        this.scrollSpy = new Utils.ScrollSpy(window, this.onPageScrolled)
        window.addEventListener('resize', this.onResize)
        this.loading = false;
    },

    watch: {
        '$route'(to, from) {
            if(this.$route.path.includes("/type") && this.$route.path.includes("Nouveau")) {
                this.metaTitle = 'Cinema Nouveau Movies | Dedicated Art Cinema'
                this.metaDescription = 'Nouveau is a division of Ster-Kinekor Theatres and holds the prestige of being one of the world’s only dedicated "art cinema" chains, screening independent, alternative and art cinema content from cultures across the globe. Book your tickets today!'
                this.metaImage = '/static/img/nouveau-logo.png'
            } else {
                this.metaTitle = 'Cinema | Movie Showtimes and Online Movie Ticket Bookings'
                this.metaDescription = 'South Africa\'s biggest movie exhibitor. Browse the latest movies, trailers and showtimes. Book your movie tickets online today!'
                this.metaImage = '/static/img/sk-logo.png'
            }
            this.$emit('updateHead');
            this.setGoogleAdPosition(window.scrollY || window.pageYOffset)
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/pages/home/home.js